<script lang="ts">
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";
  import RemoteLoading from "./RemoteLoading.svelte";

  export let totalOpportunities: number = 0;
  export let fullySynced: number = 0;
  export let lastSyncTime: string = "";

  let container: HTMLDivElement | null = null;
  let instance: any = null;
  let RemoteComponent: any = null;
  let loadError = false;

  function mount() {
    if (!container) return;
    const doMount = (Component: any) => {
      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container!,
        props: { totalOpportunities, fullySynced, lastSyncTime },
      });
    };
    if (RemoteComponent) doMount(RemoteComponent);
    else {
      // @ts-ignore - App2 remote (exposed as ./acelinkCard)
      import("App2/acelinkCard")
        .then((m) => {
          RemoteComponent = m.default;
          doMount(RemoteComponent);
        })
        .catch((err) => {
          loadError = true;
          console.warn("App2/acelinkCard not available:", err);
        });
    }
  }

  $: if (container && !instance) mount();
  $: if (instance) instance.$set({ totalOpportunities, fullySynced, lastSyncTime });

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div class="relative w-full h-full min-h-[20rem]">
  {#if !instance && !loadError}
    <RemoteLoading minHeight="20rem" />
  {/if}
  <div bind:this={container} data-ace-link-card-host class="w-full h-full min-h-[20rem]"></div>
</div>
